import {initializeFeatureToggles} from '@zs21/drv-bund-common-ilias-utils';
import $ from 'jquery';
import Sortable from 'sortablejs';
import {featureToggleConfig} from './featureToggleConfig';

initializeFeatureToggles(featureToggleConfig).then();

const IS_ADMIN = $('.il-maincontrols.nav > div.il-maincontrols-mainbar a[href*="baseClass=ilAdministrationGUI"]').length >= 1;
const FEEDBACK_TOOL_ACTIVE = true;

const queryParams = new URLSearchParams(window.location.search);


function initBilbaoAdjustments() {
	(function hideTabs() {
		if (IS_ADMIN || window.BILBAO_MANAGED !== true) {
			return;
		}

		$('#mainscrolldiv #ilTab').find('#tab_info_short,#tab_export').remove();
	})();

	(function redirectToLinkedGroup(){
		const redirectLink = document.querySelector(
			'#ilContentContainer #il_center_col a[href*="baseClass=ilLinkResourceHandlerGUI"][href*="cmd=calldirectlink"]'
		);
		if (redirectLink && redirectLink.innerText.trim().includes('HYBRID_ONLINE')) {
			redirectLink.closest('.ilContainerBlock').remove();
			window.location.href =  redirectLink.href;
			throw new Error('Redirect to another group');
		}
	})();

	(function adjustBilbaoGroupPage(){
		if (typeof window.BILBAO_DATA !== 'object') {
			return;
		}

		if ($('#mainscrolldiv #ilTab > li:not(#ilLastTab)').length < 2 && $('#mainscrolldiv .ilToolbarContainer .ilToolbar').length === 0) {
			$('#mainscrolldiv #ilTab').css('margin-top', '1rem').remove();
			$('#mainscrolldiv #ilSubTab').remove();
		}
		if (!IS_ADMIN) {
			$('button' + [
				'baseClass=ilrepositorygui',
				'cmdClass=ilObjGroupGUI',
				'cmd=editPageFrame'
			].map(v => '[onclick*="' + v + '"]').join('')).remove();
		}
		$('#mainscrolldiv #il_head_action').parent().remove();
		$('#mainscrolldiv #ilContentContainer').before('<div id="course-info-root" class="container-fluid" style="margin-bottom: 1rem; position: relative; z-index: 1;">');
	})();

	(function improveBilbaoCourseItemSorting() {
		const form = $('form' + ['baseClass=ilrepositorygui', 'cmdClass=ilObjCourseGUI', 'cmd=post'].map(v => `[action*="${v}"]`).join(''));
		if (form.length === 0) {
			return;
		}

		$('head').append('<style>' +
			'.sortable-ghost, .sortable-chosen { background: #e4f2ff; border-color: #d1e1ed }' +
			'.sortable-chosen, .sortable-drag { cursor: move }' +
			'</style>');

		form.find('.ilContainerItemsContainer').each((index, elem) => {
			const itemContainer = $(elem);

			const adjustPositionInput = () => {
				itemContainer.find('input[name^="position"]').each((index, input) => {
					input.value = (index + 1) * 10;
				});
			};

			const hideGroupsAndPlaceThemAtTheEnd = () => {
				const reorderedItems = [];
				const groupItems = [];
				itemContainer.find('> .ilObjListRow').each((index, element) => {
					const jqElement = $(element);
					const type = jqElement.attr('data-type') ?? 'unknown';
					if (type === 'grp') {
						jqElement.css('display', 'none');
						groupItems.push(element);
					} else {
						reorderedItems.push(element);
					}
				});

				if (groupItems.length === 0) {
					return;
				}

				reorderedItems.push(...groupItems);
				for (const item of reorderedItems) {
					itemContainer[0].removeChild(item);
					itemContainer[0].appendChild(item);
				}
				adjustPositionInput();
			}
			hideGroupsAndPlaceThemAtTheEnd();

			Sortable.create(itemContainer[0], {
				direction: 'vertical',
				animation: 100,
				delay: 200,
				delayOnTouchOnly: true,
				filter: '.ignore-elements',
				onChange: function () {
					adjustPositionInput();
				},
				onEnd: function () {
					adjustPositionInput();
				},
			});

		});
	})();
}

if ((new URL(window.location.href)).hostname !== 'ilias-mia.drv-bund.de') {
	const baseClass = queryParams.get('baseClass') ?? '';
	if (FEEDBACK_TOOL_ACTIVE && !['illmpresentationgui', 'ilstartupgui'].includes(baseClass.toLowerCase()) && 'force_login' !== queryParams.get('cmd') && window.location.pathname !== '/login.php') {
		$('main.il-layout-page-content > footer').after('<div id="feedback-root" style="flex-grow: 0;"></div>');
	}
	if (queryParams.get('ref_id') === '112919') {
		// @TODO: If it's integrated as a html learning module it should be extracted to a separate project like the education catalogue.
		if (!queryParams.get('cmd') ||  ['render', 'frameset'].includes(queryParams.get('cmd'))) {
			$('#ilContentContainer').html('<div id="office-eval-root"></div>');
		}
	}
	$('body').append('<div id="voucher-root"></div>');

	initBilbaoAdjustments();
}
